import { ReportConfig } from '../../dtos/interfaces/report-config';
import {
    SorterAlertHistoryReportRowDto
} from "../../../services/dtos/reports/sorter/sorter-alert-history-report-row.dto";
import moment = require('moment');

function toRecord(d: SorterAlertHistoryReportRowDto): SorterAlertHistoryReportRowDto {
    const r = new SorterAlertHistoryReportRowDto();
    r.timestampUtc = moment.utc(d.timestampUtc).local().format('YYYY-MM-DD h:mm a');
    r.deviceName = d.deviceName;
    r.alertText = d.alertText;
    r.emailSentDisplay = d.emailSent ? 'Yes' : 'No';
    return r;
}

export const alertHistoryReport: ReportConfig = {
    id: 'sorter-alert-history',
    label: 'Alert History',
    category: 'Sorter',
    showHeader: true,
    columns: [
        { key: 'timestampUtc',     label: 'Timestamp',   width: '18%'  },
        { key: 'deviceName',       label: 'Device Name', width: '32%'  },
        { key: 'alertText',        label: 'Alert',       width: '38%'  },
        { key: 'emailSentDisplay', label: 'Email Sent',  width: '12%'  },
    ],
    endpoint: 'sorter-alert-history-report',
    mapRows: (rows, search) => rows.map(toRecord),
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/reports/definitions/sorter/alert-history.report.ts